<cf2-table
      [dataSub]="data$ | async"
      [columnConfig]="columnConfig"
      sortColumn="daysSinceLastActivity"
      (selected)="viewInactiveCase($event)"
      ></cf2-table>